import React from 'react';
import { i18n } from 'config/locales';
import SummaryProgress from 'components/Section/History/SummaryProgress';
import SvgComponent from 'components/Form/SvgComponent';
import { DateModel } from 'forms/shared/types';
import { isPVQForm } from 'helpers/form';

interface Props {
  years: number;
  dates: any[];
  applicantBirthdate: DateModel;
  formType: string;
}
const ResidenceSummaryProgress: React.FC<Props> = function ({
  years, dates, applicantBirthdate, formType
}) {
  const isPvq = isPVQForm(formType);
  return isPvq ? (
    <SummaryProgress
      className="residence"
      List={() => dates}
      title={i18n.t('history.pvq.residence.summary.title')}
      unit={i18n.t('history.pvq.residence.summary.unit')}
      total={years}
      applicantBirthdate={applicantBirthdate}
      formType={formType}
    >
      <div className="summary-icon">
        <SvgComponent src="/img/residence-house.svg" alt={i18n.t('history.pvq.residence.summary.svgAlt')} />
      </div>
    </SummaryProgress>
  ) : (
    <SummaryProgress
      className="residence"
      List={() => dates}
      title={i18n.t('history.residence.summary.title')}
      unit={i18n.t('history.residence.summary.unit')}
      total={years}
      applicantBirthdate={applicantBirthdate}
      formType={formType}
    >
      <div className="summary-icon">
        <SvgComponent src="/img/residence-house.svg" alt={i18n.t('history.residence.summary.svgAlt')} />
      </div>
    </SummaryProgress>
  );
};

ResidenceSummaryProgress.defaultProps = {
  years: 10,
  dates: [],
};

export default ResidenceSummaryProgress;
